import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Row } from "react-bootstrap";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../App";
import "./../../components/button/button.css";
import "./../../components/background/background.css";
import "react-datepicker/dist/react-datepicker.css";
import Image from "../../assets/background.png";
import Header from "../../components/header/header";
import { authentication } from "../../utils/config";
import "./reservSuccess.css";
import mapping from "../../utils/areaMapping";
import Swal from "sweetalert2";
import "../../components/button/button.css";

const ReservSuccess = () => {
  const navigate = useNavigate();
  const lineProfile = useContext(AuthContext);

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();

  useEffect(() => {
    // check line account
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
      else if (response.data.clinic.vip === false) {
        await Swal.fire({
          title: "登錄產品後即可使用",
           
          icon: "warning",
        });
        return navigate("/main");
      }
    };
    auth();
  }, []);
  let time = query.get("time").slice(0, 5);
  if (time[0] === "0") time = time.slice(1);

  return (
    <Container
      fluid
      className="vh-100 d-flex flex-column  align-items-center backgroundStyle text-center"
      style={{ backgroundImage: `url(${Image})` }}
    >
      <div className="w-100 mt-3">
        <Header title="預約成功!" color="#00867F" />
      </div>
      {/* <Header title="預約成功!" color="#00867F" /> */}

      <div className="space"></div>
      <Row>
        <p className=" title ">
          <b>欲保養項目 :</b>
        </p>
        <p className="h2">
          <b>{query.get("type")}</b>
        </p>
      </Row>
      <Row>
        <p className=" title">
          <b>預約日期/時間 :</b>
        </p>
        <p className="h2">
          <b>{`${query.get("date").replace(/-/g, "/")} (${time})`}</b>
        </p>
      </Row>

      <Row>
        <p className=" title">
          <b>診所資訊 :</b>
        </p>
        <p className="h2">
          <b>{query.get("clinicName")}</b>
        </p>
        <p className="h5">
          <b>{`${mapping[query.get("areaId")]} ${query.get("address")}`}</b>
        </p>
      </Row>
      <hr></hr>
      <Row>
        <p className="title ">
          <b className="text-danger">
            ※請待客服人員傳訊息確認後<br></br>即算預約成功!
          </b>
        </p>
        <br />
        <p className=" title text-danger">
          <b>如有任何疑問請聯繫元大:</b>
          <br />
          <b>(04)2350-5000</b>
        </p>
      </Row>

      <div className="w-50 btn-custom-green d-flex justify-content-center align-items-center">
        <p
          style={{ cursor: "pointer", margin:"0"}}
          className="fs-4"
          onClick={() => {
            if (window.history.length <= 1) navigate("/main");
            else navigate(-1);
          }}
        >
          退出
        </p>
      </div>
    </Container>
  );
};

export default ReservSuccess;
